import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginUser: {},
    activeIndex: '/board/requestStatistics',
    notReadNum: '',
    isFold: false,
    multipleSelection: [],
    curStep: 1,
    totalPrice: 0,
    activeName: 'first',
    activityInviteStatus: ''
  },
  mutations: {
    updataActiveIndex (state, path) {
      // 变更状态
      state.activeIndex = path
    },
    updateLoginUser (state, loginUser) {
      // 变更状态
      state.loginUser = loginUser
    },
    updateIsFold (state, isFold) {
      // 变更状态
      state.isFold = isFold
    },
    updateNotReadNum (state, notReadNum) {
      // 变更状态
      state.notReadNum = notReadNum
    },
    updateMultipleSelection (state, multipleSelection) {
      // 变更状态
      state.multipleSelection = multipleSelection
    },
    updateCurStep (state, curStep) {
      // 变更状态
      state.curStep = curStep
    },
    updateTotalPrice (state, totalPrice) {
      // 变更状态
      state.totalPrice = totalPrice
    },
    updateActiveName (state, activeName) {
      // 变更状态
      state.activeName = activeName
    },
    updateActivityInviteStatus (state, activityInviteStatus) {
      state.activityInviteStatus = activityInviteStatus
    }
  },
  getters: {
    activeIndex: state => {
      return state.activeIndex
    },
    loginUser: state => {
      return state.loginUser
    },
    notReadNum: state => {
      return state.notReadNum
    },
    isFold: state => {
      return state.isFold
    },
    multipleSelection: state => {
      return state.multipleSelection
    },
    curStep: state => {
      return state.curStep
    },
    totalPrice: state => {
      return state.totalPrice
    },
    activeName: state => {
      return state.activeName
    },
    activityInviteStatus: state => {
      return state.activityInviteStatus
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js